import { ReserveAttributionPayload } from '@/lib/attribution';
import { LabelValuePair, SiteCategory } from './globals.type';
import { StoreReviewEntity } from './store-review.type';

export interface StoreContactEntity {
  name: string;
  phoneNumber: string;
}

export const KEYWORDS_SEPARATOR = '|';

export enum StoreType {
  DIRECT = 'direct',
  CHAIN = 'chain',
  USE = 'use',
}
export enum StoreStatus {
  ENABLE = 'enable',
  DISABLE = 'disable',
}
export enum DayOfWeek {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export interface StoreWeeklyHoursEntity {
  id: number;
  storeId: number;
  dayOfWeek: DayOfWeek;
  openTime: string;
  closeTime: string;
}

export interface StoreSubwayEntity {
  city: string;
  line: string;
  color: string;
  viewName: string;
  detail: string;
}
export interface StoreInstructorEntity {
  id: number;
  storeId: number;
  name: string;
  position: string;
  intro: string;
  isAcademicInstructorCertified: boolean;
  isPracticalInstructorCertified: boolean;
  isExaminerCertified: boolean;
  licenses: string;
}

export interface BaseStoreEntity {
  id: number;
  thumbUpfileId: number;
  regionId: number;
  name: string;
  type: StoreType;
  status: StoreStatus;
  sequence: number;
  address: string;
  roadAddress: string;
  phoneNumber: string;
  detailInfo: string;
  latitude: number;
  longitude: number;
  naverUrl: string;
  domain: string;
  subDomain: string;
  blog: string;
  facebook: string;
  instagram: string;
  twit: string;
  youtube: string;
  telegram: string;
  homepage: string;
  etcLink: string;
  convenience: string;
  keywords: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  smsSender: string;
  smsReceivers: string;
  businessRegistrationNumber: string;
  email: string;
  logoUpfileId: number;
  ownerName?: string;
  summaryAddress: string;
  cumulativeSignups: number;
  passRate: number;
  averageDurationDays: number;
  isNearTestCenter: boolean;
  isWeekendOpen: boolean;
  maxCapacity: number;
  machineCountClass1: number;
  machineCountClass2: number;
  convenienceTag: string[];
  paymentInfo: string;
  openingDate: string;
  isHot: number;
  photoPath: string;
}

export interface StoreEntity extends BaseStoreEntity {
  reviews: StoreReviewEntity[];
  weeklyHours: StoreWeeklyHoursEntity[];
  instructors: StoreInstructorEntity[];
  nearby: StoreEntity[];
  photoPaths: string[];
  registerDatetime?: string;
  modifyDatetime?: string;
  operatingHoursNote: string;
  subways?: StoreSubwayEntity[];
  keywordTags?: string; // 한글 키워드
  /** 목록 조회 시 regionSort 기준 좌표로부터의 거리(km). 기준 좌표가 없으면 생략 */
  distance?: number;
}

export interface GetStoreListParams {
  page?: number;
  limit?: number;
  province?: string;
  region?: string;
  /** SEO 지역 문자열("시도 시군구 읍면동"). 지정 시 해당 지역 대표 좌표 기준 전국 거리순 정렬 */
  regionSort?: string;
  /** regionSort 기준 좌표에서 이 거리(km) 이내 매장만. 지역 좌표를 못 찾으면 빈 목록 */
  maxDistanceKm?: number;
  types?: StoreType | StoreType[];
  keywords?: string[];
}

export interface StoreListResponse {
  totalCount: number;
  limit: number;
  stores: StoreEntity[];
}

// 추후 데이터 추가될 수 있을까봐 상속받아 사용
export type KeywordEntity = LabelValuePair;

export interface StoreReserveRequest {
  storeId: number;
  category: SiteCategory;
  inflowType: string;
  realname: string;
  phone: string;
  license: string;
  consultType: string;
  memo?: string;
  /** 선택한 요금제·요금 행 id (서버가 사이트 소속을 검증하고 표시명을 만든다) */
  pricingPlanId?: number;
  pricingPlanPriceId?: number;
  /** 신청 진입 경로 상세 (예: academy_recommend) */
  entrySource?: string;
  /** 유입 정보(처음 유입·신청 직전 유입·신청 페이지). 서버가 형식을 다시 확인해 저장한다 */
  attribution?: ReserveAttributionPayload;
}

export interface StoreReserveResponse {
  id: number;
  storeId: number;
  category: SiteCategory;
  status: string;
  reserveStatus: string;
  inflowType: string;
  realname: string;
  phone: string;
  license: string;
  consultType: string;
  memo: string;
  registerDatetime: string;
  modifyDatetime: string;
}
